import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { requerido, numero, email } from './Validaciones';

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo enviar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.nombre.text, "", "", "", "El Nombre es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.tlf.text, "", "", "", "El Teléfono es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.tlf.text, "", "", "El campo Teléfono debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.email.text, "", "", "", "El Email es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if(campos.email.text !== "") email(errores, campos.email.text, "email", "", "", "El formato de Email es incorrecto", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.mess.text, "", "", "", "El Mensaje es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){

        Post(`${Url}enviaInfoContact`, [campos], (resp) => {console.log(resp)
            mensaje = [{
                status: "info",
                mensaje: "Hemos recibido correctamente tu solicitud, espera un Email con la respuesta. Gracias por contactarnos."
            }];
            respuesta([states, mensaje, errores, nameErr])
        });

    }else{
        respuesta([states, mensaje, errores, nameErr])
    }

}


// WEBPACK FOOTER //
// ./src/funciones/ContactoFunction.jsx